export const paybill_lange={
    TH:{
        customer_not_same:'ไม่สามารถเลือกชำระเงินของลูกค้าที่แตกต่างกันได้',
        customer_data:"ข้อมูลลูกค้า",
        invoice_id: "รหัสใบแจ้งหนี้",
        create_datetime: "วันที่ออกใบแจ้งหนี้",
        customer_id: "รหัสลูกค้า",
        customer_name: "ชื่อลูกค้า",
        mobile:"เบอร์โทรศัพท์",
        email:"อีเมล์",
        due_date: "วันที่ต้องชำระ",
        fee_description: "รายละเอียดค่าธรรมเนียม",
        fee_id: "รหัสค่าธรรมเนียม",
        fee_price: "ค่าธรรมเนียม",
        fee_type_description: "ชนิดค่าธรรมเนียม",
        total_price: "ราคารวม",
        user_id: "ผู้ออกใบ",
        username: "ชื่อผู้ออกใบ",
        vat: "ภาษี",
        vat_rate: "อัตราภาษี",
        update:"ชำระเงิน",
        delete:"ลบ",
        search:"ค้นหา",
        no_internet:"เกิดข้อผิดพลากในการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง",
        back_to_paybill:"กลับไปแสดงรายการการชำระ",
        paytype:"เลือกวิธีการชำระเงิน",
        fee_data:"ข้อมูลค่าธรรมเนียม",
        close:"ปิดหน้านี้",
        update_data:"ชำระเงิน",
        alert_select_paytype:"กรุณาเลือกประการชำระเงิน",
        confirm_update:"คุณต้องการชำระเงินใช่หรือไม่?",
        want_update:"ชำระเงิน",
        updated:"ข้อมูลถูกอัพเดทเรียบร้อยแล้ว",
        confirm_delete:"คุณต้องการลบข้อมูลการชำระเงินนี้ใช่หรือไม่?",
        warining_delete:"ข้อมูลลบลบแล้วไม่สามารถยอนกลับได้!!",
        want_delete:"ฉันต้องการลบ",
        detail:"ดูรายการ",
        deleted:"ข้อมูลถูกลบเรียบร้อยแล้ว",
        all:"ทั้งหมด",
        payment_type:"ประเภทการชำระ",
        payment_description:"หมายเหตุ",
        discount:"ส่วนลด",
        cancel:"ยกเลิก",
        payment_instruction:"กดเลือกในแถวเพื่อเลือกข้อมูลไปชำระ",
        A01:"ยังไม่ชำระ",
        A02:"ชำระแล้ว",
        A03:"เคลียร์แล้ว",
        alert_payment_id:"กรุณาเลือกวิธีการชำระเงิน",
        address:"ที่อยู่",
        place_id:"รหัสที่อยู่",
        show_report:"พิมพ์ใบแจ้งหนี้",
        checked:"เฉพาะที่เลือก",
        unchecked:"เฉพาะที่ไม่เลือก"
    },
    EN:{
        customer_not_same:"Customer is not same.",
        customer_data:"customer detail",
        invoice_id: "invoice ID",
        create_datetime: "create date",
        customer_id: "customer ID",
        customer_name: "customer name",
        mobile:"phone number",
        email:"email",
        due_date: "bill date",
        fee_description: "fee description",
        fee_id: "fee ID",
        fee_price: "fee price",
        fee_type_description: "fee type",
        total_price: "total price",
        user_id: "user id",
        username:"user name",
        vat: "vat",
        vat_rate: "vat rate",
        update:"Pay",
        delete:"delete",
        search:"search",
        no_internet:"connection eror please check you connection!",
        back_to_paybill:"back to paybill data",
        paytype:"choose payment type",
        fee_data:"fee detail",
        close:"close this page",
        update_data:"Pay bill",
        alert_select_paytype:"please choose your payment type",
        confirm_update:"Are you sure to pay this bill?",
        want_update:"Yes I'm",
        updated:"This data was updated",
        confirm_delete:"Are you sure to delete this pay bill item?",
        warining_delete:"deleted data can't recovery!",
        want_delete:"Yes delete it",
        deleted:"data was deleted",
        all:"all",
        payment_type:"payment type",
        payment_description:"Remark",
        discount:"discount",
        cancel:"cancel",
        payment_instruction:"select the row to pay for the data",
        A01:"not paid",
        A02:"paid",
        A03:"clear",
        alert_payment_id:"please choose payment type",
        address:"address",
        place_id:"place ID",
        show_report:"print invoice",
        checked:"checked",
        unchecked:"unchecked"
    }
}
